import {combineReducers} from 'redux';
import {getSuccessActionType} from '../utils';
import {getErrorReducer, getStatusReducer} from './utils/generators';
import {FETCH_STUDENT_REPORTS_DATA} from '../constants/report';

function data(state = [], action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_STUDENT_REPORTS_DATA):
      return action.payload;

    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_STUDENT_REPORTS_DATA]),
  error: getErrorReducer([FETCH_STUDENT_REPORTS_DATA]),
  data
});
